const megaMenus = document.querySelectorAll(".megamenu");
const header = document.querySelector("#shopify-section-custom-header");
const headerLinks = document.querySelectorAll(
    "#shopify-section-custom-header .header__menu-item"
);

const megaMenuDisplay = (e) => {
    const hoveredElement = e.target;

    if (hoveredElement.classList.contains("header__menu-item")) {
        megaMenus.forEach((menu) => {
            if (hoveredElement.dataset.name === menu.dataset.name) {
                hoveredElement.querySelector("span").classList.add("menu-item-hovered");
                menu.classList.remove("mega-hidden");
            } else {
                menu.classList.add("mega-hidden");
                document.querySelectorAll(".menu-item-hovered").forEach(e => e.classList.remove("menu-item-hovered"));
            }
        });
    }
};

const megaMenuHide = (e) => {
    megaMenus.forEach((menu) => {
        if (!menu.classList.contains("mega-hidden")) {
            document.querySelectorAll(".menu-item-hovered").forEach(e => e.classList.remove("menu-item-hovered"));
            menu.classList.add("mega-hidden");
        }
    });
};

headerLinks.forEach((item) => {
    item.addEventListener("mouseover", megaMenuDisplay);
});

header.addEventListener("mouseleave", megaMenuHide);